import { Row } from '@tanstack/react-table'

type RowWithViewport = {
  viewport: {
    minimumWidth: number
  }
}

type TranslateViewportWidth = (
  key: 'last' | 'range',
  options: {
    currentViewportWidth: number
    nextViewportWidth?: number
  },
) => string

export const getViewportWidthCellText = <T extends RowWithViewport>({
  errorMessage,
  index,
  rows,
  t,
}: {
  errorMessage: string
  index: number
  rows: Row<T>[]
  t: TranslateViewportWidth
}): string => {
  const currentViewportWidth = rows[index]?.original.viewport.minimumWidth

  if (currentViewportWidth === undefined) {
    throw new Error(errorMessage)
  }

  const nextViewportWidth = (index: number): number =>
    rows[index + 1].original.viewport.minimumWidth

  for (let i = index; i < rows.length; i++) {
    if (i < rows.length - 1 && currentViewportWidth === nextViewportWidth(i)) {
      continue
    } else if (i < rows.length - 1) {
      return t('range', {
        currentViewportWidth,
        nextViewportWidth: nextViewportWidth(i) - 1,
      })
    } else {
      return t('last', { currentViewportWidth })
    }
  }

  throw new Error(errorMessage)
}
